import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: flex;
  column-gap: 0.25rem;
  cursor: pointer;
  align-items: center;
  & > .hefesto-icon {
    display: flex;
    align-items: center;
  }
  & svg {
    height: 1rem;
    width: 1.2rem;
  }
  &:hover {
    background-color: ${(props) => props.theme.colors.lightBlue3};
    border-radius: 0.25rem;
  }
  padding: 0.25rem 0.5rem;
`;

export const Link = styled.a<{ $disabled?: boolean; $extraPadding?: string }>`
  display: flexbox;
  padding: ${(props) =>
    props.$extraPadding ? `${props.$extraPadding}rem` : '0'};
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-style: normal;
  font-weight: 600;
  font-size: 0.75rem;
  color: ${(props) =>
    props.$disabled
      ? props.theme.colors.disabledGray
      : props.theme.colors.blue6};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};
  &:hover {
    background-color: ${(props) => props.theme.colors.lightBlue3};
    border-radius: 0.25rem;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`;
